import type { UserCustomization } from "../types.ts";

export const computeUserCustomizationStepProgress = (
  input: UserCustomization,
) =>
  input.industry !== undefined
    ? input.occupation !== undefined
      ? 0.9
      : 0.5
    : 0.2;
